import SideBarContainer from 'Containers/SideBarContainer';
import ReportsLayout from 'Pages/reports/components/ReportsLayout/ReportsLayout';
import GenericTable from './components/GenericTable/GenericTable';
import EmployeesReportFilters from './components/EmployeesReportFilters/EmployeesReportFilters';
import useEmployeeReportPage from './hooks/useEmployeeReportPage';
import type { EmployeeReportRowI } from 'types';
import { useHistory } from 'react-router-dom';
import { Padding } from 'Components/Padding';
import ProgressIndicator from 'Components/ProgressIndicator';
import ReportsTitle from 'Pages/reports/components/ReportsTitle/ReportsTitle';
import { buildTime } from 'Pages/reports/utils/buildTime';
import { FaPeopleGroup } from 'react-icons/fa6';
import { MdSchool } from 'react-icons/md';

export default function Page() {
  const { employeesReportData, employeesReportLoading, employeesReportError, t2, handleSearch, handleExport } =
    useEmployeeReportPage();

  const history = useHistory();

  const buttons = [
    { icon: <FaPeopleGroup size={24} />, tooltip: t2('employees_report_tooltip'), route: '/reporte/empleados' },
    { icon: <MdSchool size={24} />, tooltip: t2('courses_report_tooltip'), route: '/reporte/cursos' },
  ];

  return (
    <SideBarContainer>
      <ReportsLayout
        title={<ReportsTitle title={t2('title')} accent={t2('title_accent')} />}
        buttons={buttons}
        onExport={handleExport}
      />
      <Padding padding="1rem">
        <EmployeesReportFilters onSearch={handleSearch} />
        <Padding padding="0.5rem 0" />
        <GenericTable<EmployeeReportRowI>
          columns={[
            { id: 'payrollNum', label: t2('payroll_number'), align: 'center' },
            { id: 'fullName', label: t2('full_name') },
            { id: 'departmentName', label: t2('department') },
            { id: 'jobTitleName', label: t2('job_title') },
            { id: 'jobTitleTypeName', label: t2('job_title_type') },
            { id: 'gender', label: t2('gender') },
            { id: 'age', label: t2('age') },
            { id: 'entryDate', label: t2('entry_date') },
            { id: 'coursesTaken', label: t2('courses_taken'), align: 'center' },
            { id: 'pendingCourses', label: t2('pending_courses'), align: 'center' },
            { id: 'completedTrainingHours', label: t2('completed_training_hours'), align: 'center' },
            { id: 'sessionsNum', label: t2('sessions_number'), align: 'center' },
          ]}
          rows={employeesReportData.map(employee => ({
            id: employee.id,
            payrollNum: employee.payrollNum,
            fullName: employee.fullName,
            departmentName: employee.departmentName,
            jobTitleName: employee.jobTitleName,
            jobTitleTypeName: employee.jobTitleTypeName,
            gender: employee.gender,
            age: employee.age,
            entryDate: employee.entryDate,
            coursesTaken: (
              <ProgressIndicator completed={employee.completedCourses} total={employee.totalSubscribedCourses} />
            ),
            pendingCourses: `${employee.totalSubscribedCourses - employee.completedCourses}`,
            completedTrainingHours: `
              ${buildTime(employee.completedTrainingHours, t2)} / ${buildTime(employee.totalTrainingHours, t2)}
            `,
            sessionsNum: employee.sessions != null ? new Date(employee.sessions).toLocaleString() : '-',
          }))}
          loading={employeesReportLoading}
          error={employeesReportError}
          onRowClick={row => history.push(`/reporte/empleados/${row.id}`)}
        />
      </Padding>
    </SideBarContainer>
  );
}
